import PacienteTempService from "@/services/PacienteTempService";
import { bool } from "yup";
//this.$store.state.user.users,current_page
export const pacientetemp = {
    namespace:true,
    state: {pacientetemps:{},fail:bool,searchNotification:0,paramether:[] },
    actions: {
        async getListPacientetemp({commit},pageNumber){
            return await PacienteTempService.getlist(pageNumber).then(
                response=>{    
                    commit('setPacientetemps',response);                    
                },
                error => {
                    commit('setFailure');
                    return Promise.reject(error);
                })
        },
        async searchListPacientetemp({commit},search){          
            return await PacienteTempService.getSearch(search).then (
                response =>{                    
                    commit('setPacientetemps',response)
                     commit('setSearchNotify',1)
                     commit('setParamether',search)
                },
                error=>{
                    commit('setFailure')
                    return Promise.reject(error)
                }
            );
        },
        
    },
  mutations: {
    setPacientetemps(state,data){
        state.pacientetemps = data
    },
    setFailure(state){
        state.fail = false
    },
    setCurrentPage(state,data){
        state.pacientetemps.current_page = data
    },
    setSearchNotify(state,data){        
        state.searchNotification = data
    },
    setParamether(state,paramSearch){        
        state.paramether = paramSearch
    }
  }
};
